// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"ig-z","zenCrossSiteLabel":"jg-z","vrsnlCrossSiteLabel":"kg-z"};